import { cn } from '@/lib/utils';

interface RubyAvatarProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  xs: 'w-6 h-6',
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-16 h-16',
};

export function RubyAvatar({ size = 'md', className }: RubyAvatarProps) {
  return (
    <div className={cn(
      sizeClasses[size],
      "rounded-full overflow-hidden shadow-lg shadow-primary/20 flex-shrink-0 bg-primary/10",
      className
    )}>
      <svg viewBox="0 0 64 64" className="w-full h-full block" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(32 32) scale(0.85) translate(-32 -32)">
          {/* Centered gem with safe inset */}
          <polygon 
            points="14,24 24,14 40,14 50,24 32,50" 
            fill="hsl(var(--primary))"
            stroke="white"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          
          {/* Top horizontal facet line */}
          <path 
            d="M14,24 L24,28 L40,28 L50,24" 
            stroke="white" 
            strokeWidth="1.5" 
            fill="none"
            strokeLinejoin="round"
          />
          
          {/* Vertical facet lines */}
          <path d="M24,14 L24,28 L32,50" stroke="white" strokeWidth="1.5" fill="none" strokeLinejoin="round" />
          <path d="M40,14 L40,28 L32,50" stroke="white" strokeWidth="1.5" fill="none" strokeLinejoin="round" />
          
          {/* Center vertical line */}
          <path d="M32,28 L32,50" stroke="white" strokeWidth="1.5" fill="none" />
        </g>
      </svg>
    </div>
  );
}
